<template>
	<div class="app wrap">
		<NotificationTopInputAs />
		<TheHeader/>
		<Loader v-if="!dataLoad"/>
		<template v-else>
      <router-view v-slot="{ Component }">
        <transition :name="transitionName" mode="out-in" :duration="300">
          <component :is="Component" />
        </transition>
      </router-view>
		</template>
		<TheFooter/>
	</div>
</template>

<script setup lang="ts">
import '@/assets/css/general.css'
import '@/assets/css/common.css'
import TheHeader from '@/components/layout/TheHeader.vue'
import Loader from '@/components/base/Loader.vue'
// Ленивая загрузка для компонентов, которые не критичны для первоначальной загрузки
const TheFooter = defineAsyncComponent(() => import('@/components/layout/TheFooter.vue'))
const NotificationTopInputAs = defineAsyncComponent(() => import('@/components/base/NotificationTopInputAs.vue'))
import { useScripts } from '@/composables/useScripts'
import { ref, computed, onMounted, watch, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/user'
import { useGeneralStore } from '@/stores/general'

const route = useRoute()
const authStore = useAuthStore()
const userStore = useUserStore()
const generalStore = useGeneralStore()
const { insertScript } = useScripts()

const dataLoad = ref(false)
const transitionName = ref<string | undefined>(undefined)

const user = computed(() => userStore.info)

const addOnlineConsultant = async () => {
	await insertScript('//code.jivo.ru/widget/Pvke5K9pzi')
	if (typeof window.jivo_api !== 'undefined') {
		window.jivo_api.setContactInfo({
			name: user.value.name,
			email: user.value.email
		})
	}
}

const responsive = () => {
	generalStore.setScreen(window.innerWidth)
}

onMounted(async () => {
	await authStore.checkInputAs()
	await authStore.loginAction()
	dataLoad.value = true
	// await addOnlineConsultant()

	document.addEventListener('touchstart', () => {}, {passive: true})
	window.addEventListener('resize', responsive)
	responsive()
})

watch(route, (to, from) => {
	if (from.name && from.name !== to.name) {
		const toDepth = to.path.replace(/\/$/, '').split('/').length
		const fromDepth = from.path.replace(/\/$/, '').split('/').length
		transitionName.value = toDepth < fromDepth ? 'slide-right' : 'slide-left'
	}
})
</script>

<style>
	.app {position:relative;display:flex;flex-direction:column;min-height:100vh;}
	.wrap {margin:0 auto;padding:0 10px;max-width:1090px;}
	.main {margin-bottom:25px;}

	.slide-right-enter-active,
	.slide-left-enter-active,
	.slide-right-leave-active,
	.slide-left-leave-active {transform-origin:0 0;transition:transform .3s, opacity .2s;}
	.slide-left-enter, .slide-right-leave-active {opacity:0;transform:translateX(5%);}
	.slide-left-leave-active, .slide-right-enter {opacity:0;transform:translateX(-5%);}

	@media (max-width:900px) {
		.main {margin-bottom:15px;}
	}
</style>
